export const FEEDBACK_FORM_LIST = '/feedback-forms'
